/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_SubtitleInputs */

const en_fc_dl_subtitle = /** @type {(inputs: Fc_Dl_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free installers for every platform, straight from the official GitHub release. Pick your system, download, and follow the steps below.`)
};

/**
* | output |
* | --- |
* | "Free installers for every platform, straight from the official GitHub release. Pick your system, download, and follow the steps below." |
*
* @param {Fc_Dl_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_subtitle = /** @type {((inputs?: Fc_Dl_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_subtitle(inputs)
});
export { fc_dl_subtitle as "fc.dl.subtitle" }